import { AsideComponent } from './utils/aside/aside.component';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './utils/footer/footer.component';
import { HeaderComponent } from './utils/header/header.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from './../../shared/shared.module';

@NgModule({
  declarations: [
    HeaderComponent,
    AsideComponent,
    FooterComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  exports: [
    HeaderComponent,
    AsideComponent,
    FooterComponent
  ],
})
export class MainLayoutModule { }
